const siteconfig = {
    version: '2019.1.1',
    homeConfig: [
        {
            path: '/',
            key: 'home'
        },
        {
            path: '/profile',
            key: 'profile'
        },
        {
            path: '/my-funeral',
            key: 'funeral'
        },
        {
            path: '/guardians',
            key: 'guardians'
        },
        {
            path: '/contacts',
            key: 'contacts'
        },
        {
            path: '/links',
            key: 'links'
        },
        {
            path: '/account',
            key: 'account'
        },
        {
            path: '/pets',
            key: 'pets'
        },
        {
            path: '/documents',
            key: 'documents'
        },
        {
            path: '/photos',
            key: 'photos'
        },
        {
            path: '/disclaimer',
            key: 'disclaimer'
        },
        {
            path: '/imprint',
            key: 'imprint'
        }
    ],
    home: [
        {
            position: 1,
            path: '/profile'
        },
        {
            position: 2,
            path: '/my-funeral/burial'
        },
        {
            position: 3,
            path: '/guardians'
        },
        {
            position: 4,
            path: '/contacts'
        },
        {
            position: 5,
            path: '/photos'
        },
        {
            position: 6,
            path: '/documents'
        },
        {
            position: 7,
            path: '/pets'
        }
    ],
    jumbotronImages: [
        {url: 'illu_01.png'},
        {url: 'illu_02.png'},
        {url: 'illu_03.png'},
        {url: 'illu_04.png'},
        {url: 'illu_05.png'}
    ],
    validDocFileTypes: [
        'pdf',
        'doc',
        'docx',
        'xls',
        'xlsx',
        'txt'
    ],
    validPhotoFileTypes: [
        'jpg',
        'jpeg',
        'gif',
        'png',
        'tif',
        'tiff'
    ],
    validVideoFileTypes: [
        'video/quicktime',
        'video/mp4'
    ]
}

export default siteconfig



// WEBPACK FOOTER //
// ./src/assets/data/siteconfig.js